import { PlusThickIcon } from './PlusThickIcon';

/**
 * author: Austin Andrews
 * id 2FD9933D-7226-4745-B5DB-C8E6245FB170
 * name plus-thick
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus-thick.svg
 * tags
 * - Math 
 */
export const AddBoldIcon = PlusThickIcon;
export default AddBoldIcon